import _ from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import { reverse } from 'named-urls';
import routes from '@achievable-me/tundra-wizard/routes';
import { Query } from '@apollo/react-components';
import { gql } from '@apollo/client';
import SpinnerError from '$components/library/SpinnerError';
import AdminStats from './AdminStats';
import styles from './styles.scss';

const ADMIN_SOURCES = gql`
  query AdminSources {
    adminSources {
      sources
    }
  }
`;

const AdminDashboard = () => {
  return (
    <div className={styles.layout}>
      <div>Hi, this is the admin dashboard.</div>
      <br />
      <AdminStats />
      <br />
      <Query query={ADMIN_SOURCES}>
        {({ loading, error, data }) => {
          if (loading || error) {
            return <SpinnerError error={error} />;
          }

          const {
            adminSources: { sources },
          } = data;
          const sortedSources = _.sortBy(sources);

          return (
            <ul>
              <li>
                <Link to={reverse(routes.staff.charges, { partnerSlug: 'achievable' })}>
                  Charges (achievable)
                </Link>
              </li>
              {sortedSources.map((source) => (
                <li key={source}>
                  <Link to={reverse(routes.staff.charges, { partnerSlug: source })}>
                    Charges ({source})
                  </Link>
                </li>
              ))}
            </ul>
          );
        }}
      </Query>
    </div>
  );
};

export default AdminDashboard;
